angular.module("vgresiduos").controller("EquipmentAllocationCreateCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `alocacao-equipamentos/nova`);
		};
	}
]);
